export class ErrorUtil {
    static parseRestResponse(response) {
        let errorData = response.data;
        const handleInfo = ErrorUtil.parseErrorData(errorData);
        if (handleInfo.handle) {
            return handleInfo.result;
        }
        return response.message;
    }
    static parseErrorData(errorData) {
        if (typeof errorData === "string") {
            try {
                const tmp = JSON.parse(errorData);
                errorData = tmp;
            }
            catch (_) { }
        }
        if (typeof errorData === "string") {
            return { handle: true, result: errorData };
        }
        else if (errorData instanceof Object) {
            const result = errorData?.detail ||
                errorData?.message?.identifier_type ||
                errorData?.error?.message ||
                errorData?.message ||
                errorData?.non_field_errors?.[0];
            return { handle: true, result: result };
        }
        return { handle: false, result: undefined };
    }
}
ErrorUtil.defaultErrorMsg = "Something went wrong. Please try again.";
ErrorUtil.abortErrorName = "AbortError";
